import React from "react";
import { useNavigate } from "react-router-dom";
import "./ButtonBookNow.css";

const ButtonBookNow = ({ theme = "strong", pulsate = false }) => {
  const navigate = useNavigate();
  const handleClickBooking = () => {
    navigate("/booking");
    const container = document.querySelector(".full-container");
    container.scrollTo(0, 0);
  };

  return (
    <button
      className={`book-btn ${theme} ${pulsate ? "pulsate" : ""}`}
      onClick={handleClickBooking}
    >
      Boka nu
    </button>
  );
};

export default ButtonBookNow;
